import React from 'react';
import { ArrowDownIcon, CheckIcon, LightbulbIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { SectionHeading } from './SectionHeading';
import { volumes } from '../data/volumes';
export function Volumes() {
  return <section className="bg-white px-4 py-16 sm:py-24" data-id="element-327" data-mp="185q1lqmmm3tb">
      <SectionHeading eyebrow="What you’ll find inside" title={<>
            <em className="text-brand" data-id="element-329" data-mp="1zutaxktde4ct">6 Premium Volumes</em> to Help You Organize Sensory Modulation Cases
          </>} data-id="element-328" data-mp="1c4p83fo0a8mv" />

      <div className="mx-auto mt-12 max-w-5xl space-y-6 sm:space-y-8" data-id="element-330" data-mp="24tcwvl7yrg56">
        {volumes.map(v => <article key={v.numeral} className="overflow-hidden rounded-3xl border border-black/[0.06] bg-cream" data-id="element-331" data-mp="1qu3huovhus2s">
            <div className="px-5 py-5 sm:px-8 sm:py-6" style={{
          backgroundColor: v.soft
        }} data-id="element-332" data-mp="1vvkcw3rarkbg">
              <span className="inline-block rounded-full px-3 py-1 text-[12px] font-extrabold uppercase tracking-wider text-white" style={{
            backgroundColor: v.color
          }} data-id="element-333" data-mp="fhar9hefw9ob">
                Volume {v.numeral}
              </span>
              <h3 className="mt-3 text-balance font-serif text-[25px] font-extrabold leading-tight text-ink sm:text-3xl" data-id="element-334" data-mp="3jadg7j34gy8b">{v.title}</h3>
            </div>

            <div className="grid grid-cols-1 gap-6 px-5 py-6 sm:px-8 sm:py-8 lg:grid-cols-[1fr_1.1fr] lg:gap-10" data-id="element-335" data-mp="3t7j8uvrdwxan">
              <div className="space-y-4 text-[16px] leading-relaxed text-muted sm:text-[17px]" data-id="element-336" data-mp="b14u4ulakjb7">
                {v.intro.map(p => <p key={p} data-id="element-337" data-mp="620mw9hxgvni">{p}</p>)}
                {v.quote && <p className="border-l-4 pl-4 font-serif text-[19px] font-bold italic leading-snug text-ink" style={{
              borderColor: v.color
            }} data-id="element-338" data-mp="kq4xeq6tu0v7">
                    “{v.quote}”
                  </p>}
              </div>

              <div data-id="element-339" data-mp="tq1oeygovbtf">
                <p className="text-[15px] font-bold text-ink" data-id="element-340" data-mp="pqsyk4orry35">{v.listLabel}</p>
                {v.ordered ? <ol className="mt-3 space-y-2.5" data-id="element-341" data-mp="wu98ilgmgtjb">
                    {v.items.map((item, i) => <li key={item} className="flex items-start gap-3" data-id="element-342" data-mp="11sarl6e1ssus" data-mpi={i}>
                        <span className="grid h-7 w-7 shrink-0 place-items-center rounded-full text-[13px] font-extrabold text-white" style={{
                  backgroundColor: v.color
                }} data-id="element-343" data-mp="16rx3nci54320">
                          {i + 1}
                        </span>
                        <span className="pt-0.5 text-[16px] leading-snug text-ink" data-id="element-344" data-mp="1kj1xfxytu14f">{item}</span>
                      </li>)}
                  </ol> : <ul className="mt-3 space-y-2.5" data-id="element-345" data-mp="1uhhm7uadsyar">
                    {v.items.map(item => <li key={item} className="flex items-start gap-3" data-id="element-346" data-mp="3r9ro14fxja1h">
                        <CheckIcon className="mt-0.5 h-5 w-5 shrink-0" style={{
                  color: v.color
                }} aria-hidden="true" data-id="element-347" data-mp="3rbum8br8k9ha" />
                        <span className="text-[16px] leading-snug text-ink" data-id="element-348" data-mp="2ddq8mn9rl4dv">{item}</span>
                      </li>)}
                  </ul>}
              </div>
            </div>

            {(v.note || v.formula.length > 0) && <div className="px-5 sm:px-8" data-id="element-349" data-mp="24ly5yyqzezju">
                {v.note && <p className="text-[16px] leading-relaxed text-ink" data-id="element-350" data-mp="1zmv75w1lhpkb">{v.note}</p>}
                {v.formula.length > 0 && <div className="mt-3 flex flex-col items-stretch gap-1.5 sm:flex-row sm:flex-wrap sm:items-center sm:gap-2" data-id="element-351" data-mp="2wbb104bqml38">
                    {v.formula.map((f, i) => <React.Fragment key={f} data-id="element-352" data-mp="2nb4qmrbc618a" data-mpi={i}>
                        <span className="rounded-xl px-4 py-2.5 text-center text-[15px] font-bold text-white" style={{
                backgroundColor: v.color
              }} data-id="element-353" data-mp="2ne0nsdfd0lvo">
                          {f}
                        </span>
                        {i < v.formula.length - 1 && <ArrowDownIcon className="mx-auto h-4 w-4 text-muted sm:-rotate-90" aria-hidden="true" data-id="element-354" data-mp="2utu5owgak2w3" />}
                      </React.Fragment>)}
                  </div>}
              </div>}

            <div className="mx-5 mb-6 mt-6 flex items-start gap-3 rounded-2xl bg-white px-4 py-4 sm:mx-8 sm:mb-8" data-id="element-355" data-mp="2lrurebwnvcwu">
              <LightbulbIcon className="mt-0.5 h-5 w-5 shrink-0" style={{
            color: v.color
          }} aria-hidden="true" data-id="element-356" data-mp="3eimjax6p1fed" />
              <p className="text-[15px] font-semibold leading-relaxed text-ink" data-id="element-357" data-mp="3ik81my1zylvy">{v.goal}</p>
            </div>
          </article>)}
      </div>

      <CTAButton className="mt-12" label="I want all 6 volumes" data-id="element-358" data-mp="34m9p7y78kzj3" />
    </section>;
}